export default "__VITE_ASSET__C681cASw__"